import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'alg-agile-contract-hero',
  templateUrl: './alg-agile-contract-hero.component.html',
  styleUrls: ['./alg-agile-contract-hero.component.scss'],
})
export class AlgAgileContractHeroComponent implements OnInit {
  @Input() reverse: boolean;

  public typeRichiesta: string;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.typeRichiesta = params.tipo;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-agile-contract-hero/alg-agile-contract-hero.component.ts